// src/events/trade/register.ts
import { EventCategory } from "@/domain/event";
import { registerEvent } from "@/event-core/registry";
import Detail from "./Detail";
import { normalViewModelProvider } from "./provider";
import { NormalEventSkeleton } from "./Skeleton";
export const NormalRegister = () => {
    registerEvent( EventCategory.Normal, {
        getViewModel: normalViewModelProvider,
        Component: Detail,
        Skeleton: NormalEventSkeleton,
    } );
};
